import { combineReducers } from 'redux'
import {
  SISA_QUOTA_TRAYEK_ERROR,
  SISA_QUOTA_TRAYEK_LOADING,
  SISA_QUOTA_TRAYEK_SUCCESS
} from './constant'

const sisaQuotaTrayekError = (state = false, action) => {
  switch (action.type) {
    case SISA_QUOTA_TRAYEK_ERROR:
      return action.sisaQuotaTrayekError
    default:
      return state
  }
}

const sisaQuotaTrayekLoading = (state = false, action) => {
  switch (action.type) {
    case SISA_QUOTA_TRAYEK_LOADING:
      return action.sisaQuotaTrayekLoading
    default:
      return state
  }
}

const sisaQuotaTrayekSuccess = (state = false, action) => {
  switch (action.type) {
    case SISA_QUOTA_TRAYEK_SUCCESS:
      return action.sisaQuotaTrayekSuccess
    default:
      return state
  }
}

const sisaQuotaTrayek = (state = [], action) => {
  switch (action.type) {
    case SISA_QUOTA_TRAYEK_SUCCESS:
      return action.sisaQuotaTrayek
    default:
      return state
  }
}

const sisaQuotaTrayekReducer = combineReducers({
  sisaQuotaTrayekError,
  sisaQuotaTrayekLoading,
  sisaQuotaTrayekSuccess,
  sisaQuotaTrayek
})

export default sisaQuotaTrayekReducer
